'use client';

import React from 'react';

import styled from 'styled-components';

/** Portal-owned copy of shared-ui's Overlay (v0.5.383), verbatim. */

export interface OverlayProps {
  children?: React.ReactNode;
  preview?: boolean;
  showOverlay?: boolean;
  visible?: boolean;
  overlayPercentage?: number;
  zIndex?: number;
}

export const Overlay: React.FC<OverlayProps> = ({
  children,
  preview = false,
  showOverlay = true,
  visible = true,
  overlayPercentage = 50,
  zIndex = 10,
}) => (
  <StyledOverlay
    preview={preview}
    showOverlay={showOverlay}
    visible={visible}
    overlayPercentage={overlayPercentage}
    zIndex={zIndex}
  >
    {children}
  </StyledOverlay>
);

const StyledOverlay = styled.div`
  position: ${(props: any) => (props.preview ? 'absolute' : 'fixed')};
  width: 100%;
  height: 100%;
  visibility: ${(props: any) => (props.visible ? 'visible' : 'hidden')};
  display: flex;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  z-index: ${(props: any) => props.zIndex};
  background: ${(props: any) =>
    props.showOverlay ? `rgba(0, 0,0, ${props.overlayPercentage}%)` : 'transparent'};
  overscroll-behavior: none;
` as any;
